export const FEATURE_FLAG_REGISTRATION_PILOT = 'registration_pilot' as const;
export const FEATURE_FLAG_CAMPAIGNS_LEAD_CAPTURE = 'campaigns_lead_capture' as const;

export const ALL_FEATURE_FLAGS = [
  FEATURE_FLAG_REGISTRATION_PILOT,
  FEATURE_FLAG_CAMPAIGNS_LEAD_CAPTURE,
] as const;

export type FeatureFlag = (typeof ALL_FEATURE_FLAGS)[number];
